import React from "react";
import CustomModal from "../../../Core/CommonV2/CustomModal";
import { CrossIcon, CrossIcon2, CrossIconLarge } from "../../../Core/svgV2/CrossIcon";
import CustomButton from "../../../Core/CommonV2/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../Core/redux/hooks";
import {
  resetConversations,
  updateConversationsMultiple,
  groupDeletedAction,
} from "../../../Core/redux/slices/conversations.slice";
import { updateDashboard } from "../../../Core/redux/slices/dashboard.slice";
import { deleteGroup } from "../../../Core/redux/api/v3/conversationAPI";

const DeleteGroupModal = () => {
  const { deleteThread, deleteThreadDetails, currentThread } = useAppSelector(
    (state) => state.conversations
  );

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(
      updateConversationsMultiple([
        { key: "deleteThread", value: false },
        { key: "deleteThreadDetails", value: {} },
      ])
    );
  };

  const handleDelete = async () => {
    try {
      const groupName =
        deleteThreadDetails.threadName || deleteThreadDetails.name || "This";

      const result = await deleteGroup({ groupId: deleteThreadDetails.threadId });

      if (result) {
        dispatch(
          groupDeletedAction({ groupId: String(deleteThreadDetails.threadId) })
        );

        handleClose();

        if (currentThread.threadId == deleteThreadDetails.threadId) {
          dispatch(
            resetConversations([
              "showThreadProfileDrawer",
              "currentThread",
              "currentThreadMessage",
            ])
          );
        }

        dispatch(
          updateDashboard({
            key: "alertPopupModal",
            value: {
              visible: true,
              data: {
                title: `${groupName} group deleted`,
                subtitle: "",
                description: `Group was deleted`,
              },
            },
          })
        );
      }
    } catch (error) {
      console.error("[DeleteGroup] Error:", error);
    }
  };

  return (
    <CustomModal
      visible={deleteThread}
      width="360px"
      height="136px"
      onCancel={handleClose}
      body={
        <div className="p-4 flex flex-col gap-2">
          <div className="flex justify-between items-start">
            <p className="text-error-700 out-500-14">Delete group</p>
            <button
              onClick={handleClose}
              className="w-5 h-5 flex items-center justify-center shrink-0"
            >
              <CrossIconLarge className="text-gray-700" />
            </button>
          </div>
          <p className="out-300-14 text-gray-500 leading-5">
            Are you sure you want to delete this group? <br />
            This action cannot be undone.
          </p>
          <div className="flex items-center gap-x-3 justify-end w-full">
            <CustomButton
              text="Cancel"
              className="bg-transparent text-gray-500"
              height="30px"
              width="64px"
              onClick={handleClose}
            />
            <CustomButton
              text="Delete group"
              height="30px"
              width="101px"
              className="bg-error-700 text-white"
              onClick={handleDelete}
            />
          </div>
        </div>
      }
    />
  );
};

export default DeleteGroupModal;